import { render, staticRenderFns } from "./InstantPurchase.vue?vue&type=template&id=4c2a0a5e"
import script from "./InstantPurchase.vue?vue&type=script&lang=ts"
export * from "./InstantPurchase.vue?vue&type=script&lang=ts"
import style0 from "./InstantPurchase.vue?vue&type=style&index=0&id=4c2a0a5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports